import i18n from 'i18next';

import { addModal } from '@/exceed';

import styles from '../../styles/enrollments.module.scss';

export default ({ maximum }) => addModal({
  className: styles.maximumEnrollmentsBreachedModal,
  title: i18n.t('max-enrollments-reached-number', { maximum }),
  body: i18n.t('max-enrollments-reached-help-text'),
  hasCloseButton: true,
  actions: [{ action: 'okay', text: i18n.t('okay') }],
});
